export const RECEIPT_CATEGORY_TYPES = [
    {
        text: '',
    },
    {
        text: 'Advertising',
    },
    {
        text: 'Car Expense',
    },
    {
        text: 'Commission and Fees',
    },
    {
        text: 'Depletion',
    },
    {
        text: 'Depreciation and section 179',
    },
    {
        text: 'Employee Benefit',
    },
    {
        text: 'Insurance',
    },
    {
        text: 'Interest',
    },
    {
        text: 'Mortgage',
    },

    {
        text: 'Office Expense',
    },
    {
        text: 'Pension and Profit Sharing Plans',
    },
    {
        text: 'Professional or Legal Services',
    },
    {
        text: 'Rent or Lease',
    },
    {
        text: 'Repairs and Maintenance',
    },
    {
        text: 'Supplies',
    },
    {
        text: 'Taxes and Licenses',
    },
    {
        text: 'Travel',
    },
    {
        text: 'Meals and entertainment',
    },
    {
        text: 'Utilities',
    },
    {
        text: 'Wages',
    },
    {
        text: 'Other',
    },
];

export const RECEIPT_PAYMENT_TYPES = [
    {
        text: '',
    },
    {
        text: 'Cash',
    },
    {
        text: 'Check',
    },
    {
        text: 'Bank Issued Debit Card',
    },
    {
        text: 'Bank Issued Credit Card',
    },
    {
        text: 'Venmo',
    },
    {
        text: 'PayPal',
    },
    {
        text: 'Other',
    },
];
